import { useLoading } from '../../contexts/LoadingContext';
import { useMutation } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useExpertDeleteMutation = (onError: (errorMessage: string) => void) => {
    const loading = useLoading();
    const { zoneApiClient } = useZoneContext();

    return useMutation({
        mutationFn: async (expertGuid: string) => {
            loading.showLoading();
            const response = await zoneApiClient.deleteExpert(expertGuid);

            if (!response?.httpResponse.ok) {
                throw new Error('Failed to delete Expert');
            }

            return response;
        },
        onError(error) {
            if (error instanceof Error) {
                onError(error.message);
            }
        },
        onSettled: () => loading.hideLoading(),
    });
};
